import React, { Component } from 'react';
import './blog-card.scss';
import { Button } from 'reactstrap';

class BlogCard extends Component {
  render() {
    return (
      <div className="blog-card" data-aos="fade-up" data-aos-duration="800">
        <div className="card-content">
          <div>
            <div className="img-container">
              <img className="card-img" src={this.props.imgsrc} alt="" />
            </div>
            <div className="text-container">
              <h1 className="card-title">{this.props.cardTitle}</h1>
              <p className="card-text">{this.props.cardText}</p>
              <div className="micro-text-holder">
                <p className="micro-text">{this.props.category}</p>
                <p className="micro-text">{this.props.datePosted}</p>
              </div>
              <Button className="button" style={{backgroundColor: this.props.buttonColor, borderColor: this.props.buttonColor}}>Read More</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BlogCard;



// WEBPACK FOOTER //
// ./src/components/blog-card/blog-card.js